import axios from "axios";
import url1 from '../../config.js'
const url=`${url1.url}/api/course`;

export default class Course {
    constructor(course = {}) {
        this.courseId = course.courseId || "";
        this.courseTitle=course.courseTitle||"";
        this.courseDescription=course.courseDescription||"",
        this.courseStatus = course.courseStatus || true
        this.isPaid = course.isPaid || false

    }

    //api to get all courses in Courses.vue page
    static get = async (token)=>{//token) => {
        console.log('get all courses client')
        return  axios.get(`${url}`, {headers:{"x-auth-token":token}})
    }

    //api to get course count in Dashboard.vue page
    static getCourseCount = async (token) => {//(token)
        console.log('get course client')
        return  axios.get(`${url}/coursecount`, {headers:{"x-auth-token":token}});
    }

    //get course info for a particular course id for courseinfoedit page
    static getCourseById = async (course_id, token) => {//(token)
        console.log('get course by id client', course_id);
        return  axios.get(`${url}/courseinfo/${course_id}`, {headers:{"x-auth-token":token}});
    }

    //api to update course status
    static putCourseStatus( course_id, status, token) {
        console.log('put course status');
        return axios.put(`${url}/changecoursestatus/${course_id}`,{courseStatus:status}, {headers:{"x-auth-token":token}});
    }

    //api to update course paid status
    static putCoursePaidStatus( course_id, status, token) {
        console.log('put course paid status');
        return axios.put(`${url}/changecoursepaidstatus/${course_id}`,{coursePaidStatus:status}, {headers:{"x-auth-token":token}});
    }
    
    

     //used for updating course info title and description
    static saveCourse(course_id, course, token) {
        //console.log('put admin user client',adminUserEmail,adminuser)
           return axios.put(`${url}/changecourseinfo/${course_id}`, course, {headers:{"x-auth-token":token}});
        }


    //to post new course from add course page
    static postCourse(course, token) {//token
        console.log('post course client',course);
        return axios.post(`${url}`,course,{headers:{"x-auth-token":token}});
    }

     static deleteLessonFromCourse(course_id, lesson_id, token){
         console.log('model lesson_id', lesson_id);
        return (
            confirm("Are you sure you want to delete this lesson from course "+course_id+" ?") &&
            axios.delete(`${url}/deletelessonfromcourse/${course_id}`, {headers:{"x-auth-token":token}},{lesson_id:lesson_id})
            );

     }

}